import Controller from '@ember/controller';
import { action } from '@ember/object';

export default class TeamsResultsController extends Controller 
{
	@action
	refresh()
	{
		this.target.send('refreshModel');
	}
}